// extracted by mini-css-extract-plugin
export default {"special__section":"style_special__section__wtf3o","box":"style_box__XOEzd","box__header":"style_box__header__BAmUi","box__body":"style_box__body__kc8k7"};